module.exports = __webpack_public_path__ + "img/10_dp.54a579e2.png";